var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 3C6.2619 3 3 6.262 3 10.2857c0 4.0238 3.262 7.2857 7.2857 7.2857 4.0238 0 7.2857-3.2619 7.2857-7.2857C17.5714 6.2619 14.3095 3 10.2857 3zm-5.5714 7.2857c0-3.077 2.4944-5.5714 5.5714-5.5714 3.077 0 5.5714 2.4944 5.5714 5.5714 0 3.077-2.4944 5.5714-5.5714 5.5714-3.077 0-5.5714-2.4944-5.5714-5.5714z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3204 16.1082a.8572.8572 0 00-1.2122 1.2122l3.4286 3.4286a.8571.8571 0 001.2121 0 .857.857 0 000-1.2122l-3.4285-3.4286z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.3c1aec035ff90484db4280554a32e47f.svg";